import React, { type ComponentPropsWithoutRef } from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncWatchers = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-watchers-in-issue-create-modal" */ './main'),
	{ ssr: false },
);

const Watchers = (props: ComponentPropsWithoutRef<typeof AsyncWatchers>) => (
	<ErrorBoundary id="async.jira-issue-create-watchers" packageName="jiraIssueCreateWatchers">
		<Placeholder name="issue-create-watchers-modal" fallback={null}>
			<AsyncWatchers {...props} />
		</Placeholder>
	</ErrorBoundary>
);

export default Watchers;
